import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-top: 24px;
  @media (min-width: 575.98px) {
    padding-right: 12px;
  }
`;

export const Title = styled.h3`
  display: block;
  color: #9d9999;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 24px;
  font-size: 18px;
  position: relative;
`;

export const ProductContainer = styled.div`
  display: block;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  @media (min-width: 575.98px) {
    padding-right: 15px;
  }
`;
export const ProductRow = styled.div`
  display: grid;
  grid-template-areas: 'image name quantity button';
  grid-template-columns: 60px 1fr 60px 150px;
  column-gap: 12px;
  margin-bottom: 12px;
  @media (max-width: 575.98px) {
    grid-template-columns: 60px 1fr 1fr 1fr;
    grid-template-areas:
      'image name name name'
      '. quantity . .'
      '. button button .';
  }
`;

export const ProductImage = styled.div`
  grid-area: image;
  img {
    height: 60px;
    width: 60px;
    object-fit: contain;
  }
`;

export const ProductName = styled.div`
  grid-area: name;
  a {
    color: var(--black); 
    &:hover, &:active {
      color: var(--primary)
    }
  }
  .product-card__prices {
    height: auto;
  }
  .product-card__new-price, .product-card__old-price {
    font-size: 1rem;
    width: auto:
    flex: unset;
    margin-right: .5rem;
  }
`;

export const ProductQuantity = styled.div`
  grid-area: quantity;
  margin-bottom: 8px;
`;

export const ProductButton = styled.div`
  grid-area: button;
  text-align: right;

  .btn {
    width: 100%;
  }
`;
